﻿import type { AddTabToWorkspaceOptions } from 'epic/workspace/common/tabs/tabsEpics';
import { openTabInWorkspaceEpic } from 'epic/workspace/common/tabs/tabsEpics';
import type { SecondaryMarketCpOrderByOrderIdReloadRequested } from 'state/secondaryMarket/cpOrder';
import type { EpicWithThunk } from 'state/state.common';
import { secondaryOrderBlotterCPOrderTabCreatedThunk } from 'state/workspaces/secondary-market/quotes/secondaryMarketQuotes.thunks';
import type { WorkspacePersistedTabsApplied } from 'state/workspaces/workspace.actions';

export function secondaryWorkspaceReloadByOrderIdEpic(): EpicWithThunk {
  const opt: AddTabToWorkspaceOptions<SecondaryMarketCpOrderByOrderIdReloadRequested, WorkspacePersistedTabsApplied> = {
    workspaceReadyTriggers: ['WORKSPACE_PERSISTED_TABS_APPLIED'],
    targetWorkspace: 'secondaryMarketQuotes',
    triggers: ['SECONDARY_MARKET_CP_ORDER_BY_ORDER_ID_RELOAD_REQUESTED'],
    navigateRoute: { path: '/secondary-market-quotes-workspace' },
    onReady: ({ orderId }) => {
      return secondaryOrderBlotterCPOrderTabCreatedThunk(orderId);
    },
  };
  return openTabInWorkspaceEpic(opt);
}
